import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { withRouter , useHistory} from "react-router-dom"

const Logout = () => {
  
  const history = useHistory()

  useEffect(() => {
    localStorage.removeItem("authWTUser")
    history.push("/login")
  })

  return <></>
}

Logout.propTypes = {
  history: PropTypes.object,
}

export default withRouter(Logout)
